export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.21-1146.45",
  commitId: "8f440922005e6b2f0b2e39881ff35eb51568a92d",
  commitTime: "2026-05-21T11:46:45.000Z",
});
